import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface VerificationStatusState {
  verificationStatus: number;
  isVerificationStatusLoading: boolean;
}

const initialState: VerificationStatusState = {
  verificationStatus: 1,
  isVerificationStatusLoading: true,
};

export const verificationStatusSlice = createSlice({
  name: "verificationStatus",
  initialState,
  reducers: {
    setVerificationStatus: (state, action: PayloadAction<number>) => {
      state.verificationStatus = action.payload;
      state.isVerificationStatusLoading = true;
    },
    setIsVerificationStatusLoading: (state, action) => {
      state.isVerificationStatusLoading = action.payload;
    },
  },
});

export const { setVerificationStatus, setIsVerificationStatusLoading } =
  verificationStatusSlice.actions;
export const selectVerificationState = (state: any) => state.verificationStatus;
export default verificationStatusSlice.reducer;
